// TODO: Replace with real API when endpoint is available

export const mockBusiness = {
    name: 'Maple Hardware Ltd.',
    balance: 41800,
    rateBizPer100: 920,
    tier: 'Growth',
    spread: 8,
    freezeDays: 30,
    currency: 'CAD',
    redeemPer900: 90,
    distributedLast30d: 12480,
    distributedCustomers: 87,
};

export const mockPurchases = [
    {ref: 'BP-2026-0142', date: '2026-07-18', amt: 2500, biz: 23000, status: 'Confirmed'},
    {ref: 'BP-2026-0138', date: '2026-07-10', amt: 500, biz: 4600, status: 'Awaiting transfer'},
    {ref: 'BP-2026-0125', date: '2026-06-28', amt: 1000, biz: 9200, status: 'Expired'},
    {ref: 'BP-2026-0110', date: '2026-06-15', amt: 3000, biz: 27600, status: 'Confirmed'},
];

export const mockDistributionActivity = [
    {date: '2026-07-21', customer: 'Jane Smith (#1042)', rule: 'Weekend Bonus', biz: 180, status: 'Confirmed', unclaimed: false},
    {date: '2026-07-20', customer: 'Mike Chen (#1088)', rule: 'Loyalty Base', biz: 90, status: 'Frozen', freezeUntil: 'Aug 9', unclaimed: false},
    {date: '2026-07-19', customer: 'Sarah Lee (#1105)', rule: 'Category: Tools', biz: 45, status: 'In review', reviewReason: 'cap', unclaimed: false},
    {date: '2026-07-18', customer: 'Unknown (#—)', rule: 'Loyalty Base', biz: 60, status: 'Frozen', freezeUntil: 'Aug 7', unclaimed: true},
    {date: '2026-07-17', customer: 'Tom Wilson (#1156)', rule: 'Weekend Bonus', biz: -120, status: 'Reversed', unclaimed: false},
];

export const mockCustomers = [
    {
        customerNo: '1042',
        name: 'Jane Smith',
        email: 'jane.smith@email.com',
        phone: '416-555-0101',
        confirmedBiz: 1250,
        frozen: 180,
        review: 0,
        earned: 2450,
        reversed: 120,
        redeemed: 900,
        pending: 0,
    },
    {
        customerNo: '1088',
        name: 'Mike Chen',
        email: 'mike.chen@email.com',
        phone: '647-555-0188',
        confirmedBiz: 1305,
        frozen: 90,
        review: 45,
        earned: 1890,
        reversed: 0,
        redeemed: 450,
        pending: 0,
    },
    {
        customerNo: '1105',
        name: 'Sarah Lee',
        email: '',
        phone: '',
        confirmedBiz: 0,
        frozen: 0,
        review: 0,
        earned: 320,
        reversed: 0,
        redeemed: 0,
        pending: 320,
    },
    {
        customerNo: '1156',
        name: 'Tom Wilson',
        email: 'tom.w@email.com',
        phone: '905-555-0156',
        confirmedBiz: 600,
        frozen: 0,
        review: 0,
        earned: 1560,
        reversed: 240,
        redeemed: 720,
        pending: 0,
    },
];

export const mockRules = [
    {
        id: 'rule-1',
        name: 'Loyalty Base',
        condSummary: 'All transactions',
        formula: 'PerDollar',
        formulaAmount: 10,
        dailyCap: 500,
        monthlyCap: 5000,
        ver: 3,
        active: true,
        versions: [
            {
                ver: 1,
                createdAt: '2026-01-15',
                conditions: {type: 'AND', children: []},
                formula: 'PerDollar',
                formulaAmount: 8,
                dailyCap: 400,
                monthlyCap: 4000,
            },
            {
                ver: 2,
                createdAt: '2026-04-01',
                conditions: {
                    type: 'AND',
                    children: [{field: 'TotalAmount', operator: 'GreaterThan', value: 50}],
                },
                formula: 'PerDollar',
                formulaAmount: 9,
                dailyCap: 450,
                monthlyCap: 4500,
            },
            {
                ver: 3,
                createdAt: '2026-06-10',
                conditions: {
                    type: 'AND',
                    children: [{field: 'TotalAmount', operator: 'GreaterThan', value: 25}],
                },
                formula: 'PerDollar',
                formulaAmount: 10,
                dailyCap: 500,
                monthlyCap: 5000,
            },
        ],
    },
    {
        id: 'rule-2',
        name: 'Weekend Bonus',
        condSummary: 'Sat OR Sun AND TotalAmount > $100',
        formula: 'FlatAmount',
        formulaAmount: 50,
        dailyCap: 200,
        monthlyCap: 2000,
        ver: 2,
        active: true,
        versions: [
            {
                ver: 1,
                createdAt: '2026-02-20',
                conditions: {
                    type: 'OR',
                    children: [
                        {field: 'DayOfWeek', operator: 'In', value: ['Saturday', 'Sunday']},
                    ],
                },
                formula: 'FlatAmount',
                formulaAmount: 30,
                dailyCap: 150,
                monthlyCap: 1500,
            },
            {
                ver: 2,
                createdAt: '2026-05-15',
                conditions: {
                    type: 'AND',
                    children: [
                        {
                            type: 'OR',
                            children: [
                                {field: 'DayOfWeek', operator: 'In', value: ['Saturday', 'Sunday']},
                            ],
                        },
                        {field: 'TotalAmount', operator: 'GreaterThan', value: 100},
                    ],
                },
                formula: 'FlatAmount',
                formulaAmount: 50,
                dailyCap: 200,
                monthlyCap: 2000,
            },
        ],
    },
    {
        id: 'rule-3',
        name: 'Category: Tools',
        condSummary: 'LineItem.CategoryCode = TOOLS',
        formula: 'PerLineItem',
        formulaAmount: 15,
        dailyCap: 300,
        monthlyCap: 3000,
        ver: 1,
        active: false,
        versions: [
            {
                ver: 1,
                createdAt: '2026-03-01',
                conditions: {
                    type: 'AND',
                    children: [
                        {field: 'LineItem.CategoryCode', operator: 'Equals', value: 'TOOLS'},
                    ],
                },
                formula: 'PerLineItem',
                formulaAmount: 15,
                dailyCap: 300,
                monthlyCap: 3000,
            },
        ],
    },
];

export const mockReviewQueue = [
    {
        id: 'rq-001',
        wallet: '1042',
        biz: 180,
        rule: 'Weekend Bonus',
        amt: 180,
        reason: 'Daily cap exceeded',
        age: '2h',
        rev: false,
    },
    {
        id: 'rq-002',
        wallet: '1088',
        biz: 45,
        rule: 'Loyalty Base',
        amt: 45,
        reason: 'Velocity threshold',
        age: '5h',
        rev: true,
    },
    {
        id: 'rq-003',
        wallet: '1156',
        biz: 500,
        rule: 'Loyalty Base',
        amt: 500,
        reason: 'Over-reversal recovery',
        age: '1d',
        rev: false,
    },
];

export const mockAuditLog = [
    {when: '2026-07-21 14:32', who: 'admin@bizkey.ca', what: 'Purchase confirmed', why: 'EFT received BP-2026-0142'},
    {when: '2026-07-20 09:15', who: 'ops@bizkey.ca', what: 'Rule activated', why: 'Weekend Bonus v2 approved'},
    {when: '2026-07-19 16:48', who: 'finance@bizkey.ca', what: 'Manual adjustment', why: 'Customer dispute resolution #1042'},
    {when: '2026-07-18 11:22', who: 'admin@bizkey.ca', what: 'Business config updated', why: 'Freeze period changed to 30 days'},
    {when: '2026-07-17 08:05', who: 'ops@bizkey.ca', what: 'Review rejected', why: 'Velocity threshold — duplicate transaction'},
];

export const mockBizConfigs = [
    {
        business: 'Maple Hardware Ltd.',
        currency: 'CAD',
        rateBizPer100: 900,
        redeemPer900: 90,
        freezeDays: 30,
        tier: 'Gold',
    },
    {
        business: 'Northern Supply Co.',
        currency: 'CAD',
        rateBizPer100: 850,
        redeemPer900: 85,
        freezeDays: 30,
        tier: 'Silver',
    },
    {
        business: 'Pacific Tools Inc.',
        currency: 'USD',
        rateBizPer100: 920,
        redeemPer900: 92,
        freezeDays: 45,
        tier: 'Gold',
    },
];

export const mockLiability = {
    outstandingCustomerBizCad: 1842000,
    outstandingCadLiabilityDollars: 184200,
    outstandingCustomerBizUsd: 312000,
    outstandingUsdLiabilityDollars: 31900,
    undistributedBiz: 598000,
    inFreezeBiz: 148000,
    currency: 'CAD',
    byBusiness: [
        {business: 'Maple Hardware Ltd.', outstanding: 32400, undistributed: 12450, inFreeze: 4200},
        {business: 'Northern Supply Co.', outstanding: 28100, undistributed: 18900, inFreeze: 5100},
        {business: 'Pacific Tools Inc.', outstanding: 28920, undistributed: 13850, inFreeze: 3500},
    ],
};

export const mockPendingPurchases = [
    {ref: 'BP-2026-0138', business: 'Maple Hardware Ltd.', date: '2026-07-10', amt: 500, biz: 4500, eftRef: 'EFT-MH-0138'},
    {ref: 'BP-2026-0145', business: 'Northern Supply Co.', date: '2026-07-19', amt: 1500, biz: 12750, eftRef: 'EFT-NS-0145'},
];

export const mockConflictRules = [
    {id: 'rule-2', name: 'Weekend Bonus', reason: 'Overlapping conditions with Loyalty Base on weekend transactions'},
    {id: 'rule-3', name: 'Category: Tools', reason: 'Contradicting cap limits for same customer segment'},
];

export const conditionFieldOptions = [
    'PaymentMethod',
    'TotalAmount',
    'LineItem.SkuOrCode',
    'LineItem.CategoryCode',
    'TransactionDate',
    'Customer',
    'DayOfWeek',
];

export const formulaOptions = ['PerDollar', 'FlatAmount', 'PerLineItem'];

export const paymentMethodOptions = ['Visa', 'Mastercard', 'Debit', 'Cash', 'Account'];
export const dayOfWeekOptions = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const categoryOptions = ['TOOLS', 'PAINT', 'PLUMBING', 'ELECTRICAL', 'GARDEN'];
